(() => {
      const rootSelector = '[data-i18-product-faq-content]';
      const formSelector = '.section-main-product form[id^="product_form"]';
      const normaliseValue = (value) => String(value || '').trim().toLowerCase();
      const i18Models = ['iphone 18', 'iphone 18 pro', 'iphone 18 pro max', 'iphone duo'];

      const getSelectedOptionValue = (form, optionIndex) => {
        const select = form.querySelector('#productSelect-option-' + optionIndex);
        if (select && select.value) return select.value;

        const selectedRadio = form.querySelector(
          '.swatch[data-option-index="' + optionIndex + '"] input[type="radio"]:checked, input[name="option-' + optionIndex + '"]:checked'
        );
        return selectedRadio ? selectedRadio.value : '';
      };

      const resolveScope = (root, modelValue, colorValue) => {
        const model = normaliseValue(modelValue);
        const color = normaliseValue(colorValue);
        const caseScope = normaliseValue(root.dataset.i18CaseScope);

        if (!i18Models.includes(model) || !color || color.includes('aaron button')) return 'unsupported';
        if (!['edge', 'cairn', 'summa'].includes(caseScope)) return 'unsupported';
        if (model === 'iphone duo' && caseScope !== 'edge') return 'unsupported';
        return caseScope;
      };

      const setHidden = (element, hidden) => {
        if (!element) return;
        element.hidden = hidden;
        element.style.display = hidden ? 'none' : 'contents';
      };

      const syncRoot = (root, selectedOptions) => {
        const modelOptionIndex = Number.parseInt(root.dataset.i18ModelOptionIndex, 10);
        const colorOptionIndex = Number.parseInt(root.dataset.i18ColorOptionIndex, 10);
        const modelValue = selectedOptions ? selectedOptions[Number.isNaN(modelOptionIndex) ? 0 : modelOptionIndex] : '';
        const colorValue = selectedOptions ? selectedOptions[Number.isNaN(colorOptionIndex) ? 1 : colorOptionIndex] : '';
        const scope = resolveScope(root, modelValue, colorValue);
        const showI18 = scope !== 'unsupported';
        const legacy = root.parentElement.querySelector('[data-i18-legacy-faq-content]');

        setHidden(root, !showI18);
        setHidden(legacy, showI18);
        root.querySelectorAll('[data-i18-faq-scope]').forEach((content) => {
          setHidden(content, content.dataset.i18FaqScope !== scope);
        });

        /* 配置门控：独立后置 pass，不动上面那条被测试逐字引用的 scope 判定。
           条目上的 data-i18-faq-configuration 留空 = 全部配置显示；
           多值用 '||' 分隔，精确相等（配置值里没有 '|' 后缀那套东西）。
           下标为 -1（产品没有 Configuration 选项，现网全部如此）时
           configurationValue 恒为空串 => 只有同样留空的条目通过 => 行为逐位不变。
           取值三级兜底：selectedOptions -> root 上 SSR 写的 data-i18-initial-configuration。
           ⚠️ 只在 i18 内容可见时才跑：showI18 为假时整块已隐藏，再逐条改 hidden
           会在用户切回 i18 机型时留下错误的残留状态。 */
        if (!showI18) return;
        const configurationOptionIndex = Number.parseInt(root.dataset.i18ConfigurationOptionIndex, 10);
        const configurationValue = normaliseValue(
          Number.isNaN(configurationOptionIndex) || configurationOptionIndex < 0
            ? ''
            : ((selectedOptions && selectedOptions[configurationOptionIndex]) || root.dataset.i18InitialConfiguration || '')
        );
        root.querySelectorAll('[data-i18-faq-configuration]').forEach((item) => {
          const wanted = normaliseValue(item.dataset.i18FaqConfiguration);
          if (!wanted) return;
          const matches = wanted.split('||').some((allowed) => normaliseValue(allowed) === configurationValue);
          /* 🔴 必须双向切换，不能只追加 hidden。
             推荐区与 desc 的主 pass 每轮都会重置各自的条目，所以那两处「只加不减」是安全的；
             但 FAQ 的主 pass 只动 [data-i18-faq-scope] **容器**，不碰条目 => 没人替这里恢复。
             只加 hidden 的话，条目一旦被隐藏就永久消失，且不报错 ——
             德国站的 FAQ 正是这个失效模式（首屏正常、切一次变体就永久消失）。线上实测复现过。
             ⚠️ 不复用 setHidden：它会把 display 设成 'contents'（那是给 scope 容器用的），
             套到 FAQ 条目上会改掉它的布局。这里用空串还原样式表里的值。 */
          item.hidden = !matches;
          item.style.display = matches ? '' : 'none';
        });
      };

      const syncFromDom = () => {
        const form = document.querySelector(formSelector);
        if (!form) return;
        document.querySelectorAll(rootSelector).forEach((root) => {
          const modelOptionIndex = Number.parseInt(root.dataset.i18ModelOptionIndex, 10);
          const colorOptionIndex = Number.parseInt(root.dataset.i18ColorOptionIndex, 10);
          const selectedOptions = [];
          selectedOptions[Number.isNaN(modelOptionIndex) ? 0 : modelOptionIndex] = getSelectedOptionValue(
            form,
            Number.isNaN(modelOptionIndex) ? 0 : modelOptionIndex
          );
          selectedOptions[Number.isNaN(colorOptionIndex) ? 1 : colorOptionIndex] = getSelectedOptionValue(
            form,
            Number.isNaN(colorOptionIndex) ? 1 : colorOptionIndex
          );
          syncRoot(root, selectedOptions);
        });
      };

      const syncFromVariant = (variant) => {
        const selectedOptions = variant && Array.isArray(variant.options) ? variant.options : null;
        document.querySelectorAll(rootSelector).forEach((root) => syncRoot(root, selectedOptions));
      };

      syncFromDom();
      document.addEventListener('DOMContentLoaded', syncFromDom, { once: true });

      if (window.__i18ProductFaqContentEventsBound) return;
      window.__i18ProductFaqContentEventsBound = true;
      document.addEventListener('variant:change', (event) => {
        const variant = event.detail && Object.prototype.hasOwnProperty.call(event.detail, 'variant')
          ? event.detail.variant
          : null;
        syncFromVariant(variant);
      });

      /* FAQ 子手风琴的点击处理器。
         markup（.faq-item / .faq-title / .faq-content.hidden / .toggleIcon）线上早已铺好，
         但**全站没有任何地方绑过它** —— 实测 title.click()、真 MouseEvent、jQuery.trigger('click')
         三种触发都不会移除 .faq-content 的 hidden 类，所以答案永远打不开。
         这里补上唯一的一处绑定，放在既有的 once 守卫之后，与 variant:change 共用它。

         几条刻意的选择：
         - 委托到 document 并用 closest('.faq-item') 定界，而不是逐个元素绑：
           i18 与 legacy 两套 FAQ 内容会被 syncRoot 反复切换显隐，逐个绑会漏掉后到的节点；
         - 各条目**独立开合**，点一条不收起其它条（FAQ 列表的常规行为，也避免误收起用户正在读的那条）；
         - 只动 .faq-content 的 class 与 .toggleIcon 的 class，
           不碰条目自身的 hidden 属性与 style.display —— 那是配置门控 pass 的地盘，
           两边写同一个属性会互相踩（门控隐藏的条目不该因为点过就复活）。 */
      const FAQ_OPEN_ICON_CLASSES = ['transform', 'rotate-180'];
      const toggleFaqItem = (title) => {
        const item = title.closest('.faq-item');
        if (!item) return;
        const content = item.querySelector('.faq-content');
        if (!content) return;
        const willOpen = content.classList.contains('hidden');
        content.classList.toggle('hidden', !willOpen);
        const icon = title.querySelector('.toggleIcon');
        if (icon) FAQ_OPEN_ICON_CLASSES.forEach((cls) => icon.classList.toggle(cls, willOpen));
        title.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      };

      document.addEventListener('click', (event) => {
        const title = event.target.closest('.faq-title');
        if (title) toggleFaqItem(title);
      });

      /* <h3> 默认不可聚焦，键盘用户拿不到这个开合。补最小可用的一套：
         绑定时补 role/tabindex/aria-expanded，并让 Enter / Space 走同一条路径。 */
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        const title = event.target.closest && event.target.closest('.faq-title');
        if (!title) return;
        event.preventDefault();
        toggleFaqItem(title);
      });

      const markFaqTitlesFocusable = () => {
        document.querySelectorAll('.faq-title').forEach((title) => {
          if (title.dataset.faqTitleBound) return;
          title.dataset.faqTitleBound = '1';
          title.setAttribute('role', 'button');
          title.setAttribute('tabindex', '0');
          const content = title.closest('.faq-item') && title.closest('.faq-item').querySelector('.faq-content');
          title.setAttribute('aria-expanded', content && !content.classList.contains('hidden') ? 'true' : 'false');
        });
      };
      markFaqTitlesFocusable();
      document.addEventListener('DOMContentLoaded', markFaqTitlesFocusable, { once: true });
    })();
